import React, { useEffect, useState } from "react";
import { customerVerifyList } from "../../../redux/actions/customerVerificationAction";
import { useDispatch } from "react-redux";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import CustomerVerificationTableData from "./customerVerificationTableData";
import NumberPagination from "../../../components/Pagination/number-pagination";

const CustomerVerifyListTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [loading, setLoading] = useState(false);
  const [customerListData, setCustomerListData] = useState([]);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    fetchCustomerList();
  }, [page, search]);

  const fetchCustomerList = () => {
    dispatch(customerVerifyList({ page, search }, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setLoading(false);
    setCustomerListData(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table" style={{ position: "relative" }}>
            <thead>
              <tr className="table-rows color_747f9e">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads " width={"10%"}>
                  Jivini’s Doctor Code
                </th>
                <th className="table-heads " width={"10%"}>
                  Jivini’s Pharmacy Code
                </th>
                <th className="table-heads " width={"12%"}>
                  Doctor Name
                </th>
                <th className="table-heads " width={"12%"}>
                  Pharmacy Name
                </th>
                <th className="table-heads " width={"8%"}>
                  City
                </th>
                <th className="table-heads " width={"8%"}>
                  Pharmacy Type
                </th>
                <th className="table-heads " width={"8%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable show={loading} />
                </div>
              ) : customerListData?.customers?.length > 0 ? (
                <>
                  {customerListData?.customers?.map((eachRow, index) => (
                    <CustomerVerificationTableData
                      data={eachRow}
                      key={index}
                      index={index}
                      fetchCustomerList={fetchCustomerList}
                      currentPage={customerListData?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          <NumberPagination
            setCurrentPage={setPage}
            pagination={customerListData?.pagination?.currentPage}
            totalPages={customerListData?.pagination?.totalPages}
            path={"/support/customer-verification"}
            filters={`${queryString}`}
          />
        </div>
      </div>
    </>
  );
};

export default CustomerVerifyListTable;
